module.exports = __webpack_public_path__ + "static/media/nature.325db07d.jpg";